import axios from 'axios';
import store from './store/store';

// let ht = JSON.parse(localStorage.getItem('ht'))
// let pdv = JSON.parse(localStorage.getItem('pdv'))
// let pos = JSON.parse(localStorage.getItem('pos'))
let getBaseUrl = () => {
  if(window.location.hostname === 'localhost' || window.location.hostname.includes('one-checkout') || window.location.hostname.includes('192')) {
    return process.env.VUE_APP_SERVER
  } else {
    let apiUrl = 'https://' + window.location.host.replace('checkout', 'api') + '/api/'
    return apiUrl
  }
}

const http = axios.create({
  baseURL: getBaseUrl(),
  // headers: {
  //   // PDV: store.getters.pdv,
  //   // POS: store.getters.pos,
  //   // TERMINAL: ht
  // },
});

// Add a request interceptor
http.interceptors.request.use(
  function(config) {
    if (
      config.url !== 'auth/loginposkeycloak' &&
      config.url !== 'clients/details'
    ) {
      let pos = store.getters.pos
      let pdv = store.getters.pdv

      if (window.location.pathname.includes('/event/natal-luz') || window.location.pathname.includes('totem')) {
        pos = 4382
        pdv = 31821
      }
      
      if (pos) config.headers.POS = pos;
      if (pdv) config.headers.PDV = pdv;

      const ht = localStorage.getItem('ht')
      if (ht) config.headers.TERMINAL = ht.replaceAll('"', "");

      const accessToken = store.getters.userToken;
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    } else if (config.url === 'clients/details') {
      const accessToken = store.getters.clientToken;
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    }

    store.dispatch('addLoading');

    // Do something before request is sent
    return config;
  },
  function(error) {
    store.dispatch('subtractLoading');
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
http.interceptors.response.use(
  function(response) {
    store.dispatch('subtractLoading');
    if (response.status === 200) {
      if (response.data.error) {
        store.dispatch('openSnackbar', {
          message: response.data.message || response.data.error,
        });
      }
    }
    // Do something with response data
    return response;
  },
  function(error) {
    if (error && error.response && error.response.status === 401) {
      // store.dispatch('openSnackbar', { message: 'Login inválido' });
    } else if (error && error.response && error.response.status === 422) {
      if (error.response.data) {
        const { data } = error.response;
        let errorMessages = `${data.message}\n`;
        Object.values(data.errors).forEach(error => {
          Object.values(error).forEach(message => {
            errorMessages += `${errorMessages}${message}\n`;
          });
        });
        store.dispatch('openSnackbar', { message: errorMessages });
      }
    } else if (error && error.response && error.response.status >= 500) {
      store.dispatch('openSnackbar', { message: 'Ocorreu um erro ao processar sua solicitação' });
    }
    store.dispatch('subtractLoading');

    // Do something with response error
    return Promise.reject(error);
  }
);

export default http;
